export const updateUnsuccessMsg = (msg) => { 
    return {
        type:'UPDATE_UNSUCCESS_MSG',
        msg
    }
}

export const updateUnsuccessRedirectUrl = (redirectUrl) => { 
    return {
        type:'UPDATE_UNSUCCESS_REDIRECT_URL',
        redirectUrl
    }
}